/* eslint-disable react/jsx-filename-extension */
import { MOBILE_OS } from '@src/constants/os';

/* eslint-disable react/react-in-jsx-scope */
const { getMobileOperatingSystem } = require('@src/utils/osMobile');

export const redirectToSMSApp = ({ body, target, content }) => {
  let href = '';
  const osDevice = getMobileOperatingSystem();
  if (osDevice === MOBILE_OS.ANDROID || osDevice === MOBILE_OS.WIN_PHONE) {
    href = `sms:${target}?body=${body}`;
  }
  if (osDevice === MOBILE_OS.IOS) {
    href = `sms:${target}&body=${body}`;
  }

  return (
    <a style={{ textDecoration: 'none' }} href={href}>
      {content}
    </a>
  );
};
